export default __webpack_public_path__ + "static/media/029-no overtaking.58426286.png";